<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Site {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true"
            class="heading-small text-muted mb-4 text-truncate">View Site - {{ this.inputName }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Site - {{ this.inputName }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{ inputCreatedBy }} | {{ inputCreatedAt | dateFilter}}
                <br>
                <b><label>Updated By:</label></b>
                {{ inputUpdatedBy }} | {{ inputUpdatedAt | dateFilter}}
                <div class="card shadow">
                    <a-table
                        :columns="siteHistoryColumns"
                        :dataSource="siteHistoryData"
                        :loading="loading"
                        
                        :pagination="pagination"
                        bordered
                    >
                    </a-table>
                </div>
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <!-- {{site}} -->
            <div v-if="customFormMode == 1" v-show="showDetails">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName"
                            input-classes="form-control" required />
                        <base-input label="Location" required>
                            <br>
                            <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations"
                                style="width: 100%" changeOnSelect :disabled="$attrs.viewMode"/>
                        </base-input>
                        <base-input alternative="" label="Site Brand" placeholder="" input-classes="form-control" >
                            <a-select v-model="inputBrandName" showSearch  optionFilterProp="children" :disabled="$attrs.viewMode" >
                                <a-select-option v-for="brand in brandList" :key="brand.brand_no" :value="brand.brand_no">{{brand.name}}</a-select-option> 
                            </a-select>
                        </base-input>
                        <base-input alternative="" label="Ownership Type" placeholder="" input-classes="form-control" required>
                            <a-select v-model="inputOwnershipType" :disabled="$attrs.viewMode">
                                <a-select-option value="owned">Owned</a-select-option>
                                <a-select-option value="franchise">Franchise</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete :disableInput="isSiteTypeDisabled" ref="autocomplete"
                                        placeholder="Search Site Type" :source="siteTypeEndpoint"
                                        input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Company" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Company"
                                        :source="companyEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin"
                            input-classes="form-control" required />
                        <base-input alternative="" label="Site Address" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <base-input alternative="" label="Area Code" placeholder="" v-model="inputAreaCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Site IP Address" placeholder="" v-model="ipAddress"
                            input-classes="form-control" />

                        <!--  Contact Details-->
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="contactPerson"
                            input-classes="form-control" />
                        <base-input alternative="" label="Contact Number" placeholder="" v-model="contactNumber"
                            input-classes="form-control" />
                        <base-input label="Email">
                            <br>
                            <a-select v-model="inputEmail" mode="tags" style="width: 100%"
                                :token-separators="[',']" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                        <hr>
                        <h4>Site Checklist</h4>
                        <base-checkbox v-if="ownerAccount" class="mb-3" v-model="checkboxes.isLive">
                            This is a Live Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Terminal"
                                        :source="termialEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication"
                            :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br />
                            <span v-if="disableReplication">Site Replicated : {{ this.inputReplicateSiteId }}</span>
                            <autocomplete ref="autocomplete" placeholder="Search Sites" :source="sitesEndpoint"
                                :disable-input="disableReplication" input-class="form-control" results-property="data"
                                :results-display="formattedDisplay" :request-headers="authHeaders" @selected="getSite">
                            </autocomplete>
                        </base-input>
                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset" @change='onChange'/>
                            </div>
                        </base-input>
                        <br><br>
                        <h4 >Table Template Checklist</h4>
                        <base-input alternative="" label="Select no. of tables to create (Default is 0):">
                            <a-select v-if="profileId == 0" v-model="inputNoOfTables" optionFilterProp="children" style="width: 100%">
                                <a-select-option value=0>0</a-select-option>
                                <a-select-option value=50>50</a-select-option>
                                <a-select-option value=100>100</a-select-option>
                            </a-select>
                            <a-select v-else v-model="inputNoOfTables" optionFilterProp="children" style="width: 100%" disabled>
                                <a-select-option value=0>0</a-select-option>
                                <a-select-option value=50>50</a-select-option>
                                <a-select-option value=100>100</a-select-option>
                            </a-select>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Default Sublocation" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input alternative="" label="Code" placeholder="" v-model="inputSublocationCode"
                                input-classes="form-control" />
                            <base-input alternative="" label="Name" placeholder="" v-model="inputSublocationName"
                                input-classes="form-control" required />
                            <base-input label="Type">
                                <select class="form-control form-control-sm" v-model="inputSublocationType">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key"
                                        v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete ref="autocomplete" placeholder="Search Salesman"
                                            :source="salesmanEndpoint" input-class="form-control"
                                            results-property="data" :results-display="formattedDisplay"
                                            :request-headers="authHeaders" @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription" />
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags" />
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete ref="autocomplete" placeholder="Search Sublocation"
                                            :source="sublocationEndpoint" input-class="form-control"
                                            results-property="data" :results-display="formattedDisplay"
                                            :request-headers="authHeaders" @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <br><br><br><br>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Branch Console" key="3">
                        <base-alert v-if="profileId == 0 || !siteTerminals.length" type="warning">
                            Terminals must be added to this site before enabling Branch Console
                        </base-alert>
                        <base-input alternative="" label="Enable Branch Console" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableBranchConsole" :disabled="$attrs.viewMode || profileId == 0 || !siteTerminals.length" />
                        </base-input>
                        <base-input alternative="" label="Branch Console Host Address" v-model="branch_console_host"
                            input-classes="form-control" placeholder="x.x.x.x" :disabled="$attrs.viewMode"
                            required v-if="enableBranchConsole"/>
                        <base-input alternative="" label="Master Terminal" placeholder="" input-classes="form-control"
                            required v-if="enableBranchConsole">
                            <a-select v-model="branch_console_master_terminal" allowClear :disabled="$attrs.viewMode">
                                <a-select-option v-for="terminal in siteTerminals" :key=terminal.id :value=terminal.id>{{ `${terminal.name} [${terminal.code}]` }}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Centralization Mode" class="w-100 d-flex flex-column align-items-stretch">
                            <a-radio-group v-model="centralizationMode" button-style="solid" class="d-flex justify-content-center"
                                :disabled="$attrs.viewMode">
                                <a-radio-button class="col-4" value="0" defaultChecked>Normal</a-radio-button>
                                <a-radio-button class="col-4" value="1">Centralized</a-radio-button>
                                <a-radio-button class="col-4" value="2">Decentralized</a-radio-button>
                            </a-radio-group>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Printers" key="4">
                        <base-input label="Invoice Printers">
                            <br>
                            <a-table :columns="usbPrinterColumns" :dataSource="usbPrinters" :pagination="false" size="small" bordered>
                                <template slot="is_enabled" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeUsbPrinter(e.target.checked, index, 'is_enabled')" :value="text" :checked="record.is_enabled" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template v-for="col in ['max_character_length', 'product_id', 'vendor_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e.target.value, index, col)" :disabled="$attrs.viewMode" />
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e, index, 'type')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="type in networkPrinterTypes" :key="type.id" :value="type.id">{{ type.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{ networkPrinterTypes.find(type => type.id == text) ? ` (${networkPrinterTypes.find(type => type.id == text).name})` : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="record.editable">
                                            <a-button @click="() => saveUsbPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelUsbPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyUsbPrinter !== ''" @click="() => editUsbPrinter(index)" class="btn btn-warning btn-sm">Edit</a-button>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                        <base-input label="Network Printers">
                            <br>
                            <a-table :columns="networkPrinterColumns" :dataSource="networkPrinters" :pagination="false" size="small" bordered>
                                <template v-for="col in ['name', 'max_character_length', 'network_address']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeNetworkPrinter(e.target.value, index, col)" :disabled="$attrs.viewMode"/>
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeNetworkPrinter(e, index, 'type')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="type in networkPrinterTypes" :key="type.id" :value="type.id">{{ type.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{ networkPrinterTypes.find(type => type.id == text) ? ` ${networkPrinterTypes.find(type => type.id == text).name}` : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="is_default" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeNetworkPrinter(e.target.checked, index, 'is_default')" :value="text" :checked="record.is_default" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="is_dispatch" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeNetworkPrinter(e.target.checked, index, 'is_dispatch')" :value="text" :checked="record.is_dispatch" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == networkPrinters.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyNetworkPrinter !== ''" @click="() => addNetworkPrinter()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveNetworkPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelNetworkPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode ||editingKeyNetworkPrinter !== ''" @click="() => editNetworkPrinter(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyNetworkPrinter !== ''" title="Sure to delete?" @confirm="() => deleteNetworkPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                        <!-- <base-input label="Sticker Printers">
                            <br>
                            <a-table :columns="usbPrinterColumns" :dataSource="usbPrinters" :pagination="false" size="small" bordered>
                                <template slot="is_enabled" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeUsbPrinter(e.target.checked, index, 'is_enabled')" :value="text" :checked="record.is_enabled" :disabled="!record.editable"/>
                                    </div>
                                </template>
                                <template v-for="col in ['max_character_length', 'type', 'product_id', 'vendor_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e.target.value, index, col)" />
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e, index, 'type')">
                                            <a-select-option key="1" value="1">Thermal</a-select-option>
                                            <a-select-option key="2" value="2">Dot Matrix</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{_.startCase(text)}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="record.editable">
                                            <a-button @click="() => saveUsbPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelUsbPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="editingKeyUsbPrinter !== ''" @click="() => editUsbPrinter(index)" class="btn btn-warning btn-sm">Edit</a-button>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input> -->
                    </a-tab-pane>
                    <a-tab-pane tab="Kitchen Printing" key="5">
                        <base-input label="Kitchen Printer Areas">
                            <br>
                            <a-table :columns="kitchenPrinterAreaColumns" :dataSource="kitchenPrinterAreas" :pagination="false" size="small" bordered>
                                <template slot="name" slot-scope="text, record, index">
                                    <div>
                                        <a-input v-if="record.editable" type="text" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrinterArea(e.target.value, index, 'name')" :disabled="$attrs.viewMode"/>
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template v-for="col in ['primary_printer_id', 'secondary_printer_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrinterArea(e, index, col)" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="(printer) in networkPrinters" :key="printer.id" :value="printer.id" >{{ printer.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <!-- {{_.startCase(text)}} -->
                                            {{ networkPrinters.find(printer => printer.id == text) ? networkPrinters.find(printer => printer.id == text).name : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="default" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeKitchenPrinterArea(e.target.checked, index, 'default')" :value="text" :checked="record.default" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == kitchenPrinterAreas.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" @click="() => addKitchenPrinterArea()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveKitchenPrinterArea(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelKitchenPrinterArea(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" @click="() => editKitchenPrinterArea(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" title="Sure to delete?" @confirm="() => deleteKitchenPrinterArea(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>

                        <base-input label="Kitchen Printer Routing" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableKitchenPrintingRouting" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input label="Docket Clipping Space" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableDocketClippingSpace" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input label="Kitchen Printing Routes" v-if="enableKitchenPrintingRouting">
                            <br>
                            <a-table :columns="kitchenPrintingRouteColumns" :dataSource="kitchenPrintingRoutes" :pagination="false" size="small" bordered>
                                <template slot="category_ids" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" :value="text" :filterOption="filterOption" option-filter-prop="children" mode="multiple" @change="e => handleChangeKitchenPrintingRoute(e, index, 'category_ids')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="cat in kitchenCategoryOptions" :key="cat.id"  >
                                                {{ cat.category_name }}
                                            </a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <a-tag v-for="value in text" :key="value" color="#00BFFF" >
                                                {{ kitchenCategoryOptions.find(cat => cat.id == value) ? kitchenCategoryOptions.find(cat => cat.id == value).category_name : value }}
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template slot="kitchen_printer_area_id" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrintingRoute(e, index, 'kitchen_printer_area_id')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="area in kitchenPrinterAreas" :key="area.id" :value="area.id">
                                                {{ area.name }}
                                            </a-select-option>
                                            <!-- <a-select-option v-for="area in kitchenPrinterAreas" :key="area.id" :value="area.id"></a-select-option>
                                                {{ area.name }} ({{ area.id }})
                                            </a-select-option> -->
                                        </a-select>
                                        <template v-else>
                                            {{ kitchenPrinterAreas.find(area => area.id == text) ? kitchenPrinterAreas.find(area => area.id == text).name : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == kitchenPrintingRoutes.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" @click="() => addKitchenPrintingRoute()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveKitchenPrintingRoute(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelKitchenPrintingRoute(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" @click="() => editKitchenPrintingRoute(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" title="Sure to delete?" @confirm="() => deleteKitchenPrintingRoute(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
                    :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName"
                            input-classes="form-control" required />
                        <base-input label="Location" required>
                            <br>
                            <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations"
                                style="width: 100%" changeOnSelect :disabled="$attrs.viewMode"/>
                        </base-input>
                        <base-input alternative="" label="Site Brand" placeholder="" input-classes="form-control" >
                            <a-select v-model="inputBrandName" showSearch  optionFilterProp="children" :disabled="$attrs.viewMode" >
                                <a-select-option v-for="brand in brandList" :key="brand.brand_no" :value="brand.brand_no">{{brand.name}}</a-select-option> 
                            </a-select>
                        </base-input>
                        <base-input alternative="" label="Ownership Type" placeholder="" input-classes="form-control" required>
                            <a-select v-model="inputOwnershipType" :disabled="$attrs.viewMode">
                                <a-select-option value="owned">Owned</a-select-option>
                                <a-select-option value="franchise">Franchise</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete :disableInput="isSiteTypeDisabled" ref="autocomplete"
                                        placeholder="Search Site Type" :source="siteTypeEndpoint"
                                        input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Company" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Company"
                                        :source="companyEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin"
                            input-classes="form-control" required />
                        <base-input alternative="" label="Site Address" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <base-input alternative="" label="Area Code" placeholder="" v-model="inputAreaCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Site IP Address" placeholder="" v-model="ipAddress"
                            input-classes="form-control" />

                        <!--  Contact Details-->
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="contactPerson"
                            input-classes="form-control" />
                        <base-input alternative="" label="Contact Number" placeholder="" v-model="contactNumber"
                            input-classes="form-control" />
                        <base-input label="Email">
                            <br>
                            <a-select v-model="inputEmail" mode="tags" style="width: 100%"
                                :token-separators="[',']" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                        <hr>
                        <h4>Site Checklist</h4>
                        <base-checkbox v-if="ownerAccount" class="mb-3" v-model="checkboxes.isLive">
                            This is a Live Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Terminal"
                                        :source="termialEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication"
                            :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br />
                            <span v-if="disableReplication">Site Replicated : {{ this.inputReplicateSiteId }}</span>
                            <autocomplete ref="autocomplete" placeholder="Search Sites" :source="sitesEndpoint"
                                :disable-input="disableReplication" input-class="form-control" results-property="data"
                                :results-display="formattedDisplay" :request-headers="authHeaders" @selected="getSite">
                            </autocomplete>
                        </base-input>
                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset" @change='onChange'/>
                            </div>
                        </base-input>
                        <br><br>
                        <h4 >Table Template Checklist</h4>
                        <base-input alternative="" label="Select no. of tables to create (Default is 0):">
                            <a-select v-if="profileId == 0" v-model="inputNoOfTables" optionFilterProp="children" style="width: 100%">
                                <a-select-option value=0>0</a-select-option>
                                <a-select-option value=50>50</a-select-option>
                                <a-select-option value=100>100</a-select-option>
                            </a-select>
                            <a-select v-else v-model="inputNoOfTables" optionFilterProp="children" style="width: 100%" disabled>
                                <a-select-option value=0>0</a-select-option>
                                <a-select-option value=50>50</a-select-option>
                                <a-select-option value=100>100</a-select-option>
                            </a-select>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Default Sublocation" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input alternative="" label="Code" placeholder="" v-model="inputSublocationCode"
                                input-classes="form-control" />
                            <base-input alternative="" label="Name" placeholder="" v-model="inputSublocationName"
                                input-classes="form-control" required />
                            <base-input label="Type">
                                <select class="form-control form-control-sm" v-model="inputSublocationType">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key"
                                        v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete ref="autocomplete" placeholder="Search Salesman"
                                            :source="salesmanEndpoint" input-class="form-control"
                                            results-property="data" :results-display="formattedDisplay"
                                            :request-headers="authHeaders" @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription" />
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags" />
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete ref="autocomplete" placeholder="Search Sublocation"
                                            :source="sublocationEndpoint" input-class="form-control"
                                            results-property="data" :results-display="formattedDisplay"
                                            :request-headers="authHeaders" @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <br><br><br><br>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Branch Console" key="3">
                        <base-alert v-if="profileId == 0 || !siteTerminals.length" type="warning">
                            Terminals must be added to this site before enabling Branch Console
                        </base-alert>
                        <base-input alternative="" label="Enable Branch Console" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableBranchConsole" :disabled="$attrs.viewMode || profileId == 0 || !siteTerminals.length" />
                        </base-input>
                        <base-input alternative="" label="Branch Console Host Address" v-model="branch_console_host"
                            input-classes="form-control" placeholder="x.x.x.x" :disabled="$attrs.viewMode"
                            required v-if="enableBranchConsole"/>
                        <base-input alternative="" label="Master Terminal" placeholder="" input-classes="form-control"
                            required v-if="enableBranchConsole">
                            <a-select v-model="branch_console_master_terminal" allowClear :disabled="$attrs.viewMode">
                                <a-select-option v-for="terminal in siteTerminals" :key=terminal.id :value=terminal.id>{{ `${terminal.name} [${terminal.code}]` }}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Centralization Mode" class="w-100 d-flex flex-column align-items-stretch">
                            <a-radio-group v-model="centralizationMode" button-style="solid" class="d-flex justify-content-center"
                                :disabled="$attrs.viewMode">
                                <a-radio-button class="col-4" value="0" defaultChecked>Normal</a-radio-button>
                                <a-radio-button class="col-4" value="1">Centralized</a-radio-button>
                                <a-radio-button class="col-4" value="2">Decentralized</a-radio-button>
                            </a-radio-group>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Printers" key="4">
                        <base-input label="Invoice Printers">
                            <br>
                            <a-table :columns="usbPrinterColumns" :dataSource="usbPrinters" :pagination="false" size="small" bordered>
                                <template slot="is_enabled" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeUsbPrinter(e.target.checked, index, 'is_enabled')" :value="text" :checked="record.is_enabled" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template v-for="col in ['max_character_length', 'product_id', 'vendor_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e.target.value, index, col)" :disabled="$attrs.viewMode" />
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e, index, 'type')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="type in networkPrinterTypes" :key="type.id" :value="type.id">{{ type.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{ networkPrinterTypes.find(type => type.id == text) ? ` (${networkPrinterTypes.find(type => type.id == text).name})` : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="record.editable">
                                            <a-button @click="() => saveUsbPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelUsbPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyUsbPrinter !== ''" @click="() => editUsbPrinter(index)" class="btn btn-warning btn-sm">Edit</a-button>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                        <base-input label="Network Printers">
                            <br>
                            <a-table :columns="networkPrinterColumns" :dataSource="networkPrinters" :pagination="false" size="small" bordered>
                                <template v-for="col in ['name', 'max_character_length', 'network_address']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeNetworkPrinter(e.target.value, index, col)" :disabled="$attrs.viewMode"/>
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeNetworkPrinter(e, index, 'type')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="type in networkPrinterTypes" :key="type.id" :value="type.id">{{ type.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{ networkPrinterTypes.find(type => type.id == text) ? ` ${networkPrinterTypes.find(type => type.id == text).name}` : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="is_default" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeNetworkPrinter(e.target.checked, index, 'is_default')" :value="text" :checked="record.is_default" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="is_dispatch" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeNetworkPrinter(e.target.checked, index, 'is_dispatch')" :value="text" :checked="record.is_dispatch" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == networkPrinters.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyNetworkPrinter !== ''" @click="() => addNetworkPrinter()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveNetworkPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelNetworkPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode ||editingKeyNetworkPrinter !== ''" @click="() => editNetworkPrinter(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyNetworkPrinter !== ''" title="Sure to delete?" @confirm="() => deleteNetworkPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                        <!-- <base-input label="Sticker Printers">
                            <br>
                            <a-table :columns="usbPrinterColumns" :dataSource="usbPrinters" :pagination="false" size="small" bordered>
                                <template slot="is_enabled" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeUsbPrinter(e.target.checked, index, 'is_enabled')" :value="text" :checked="record.is_enabled" :disabled="!record.editable"/>
                                    </div>
                                </template>
                                <template v-for="col in ['max_character_length', 'type', 'product_id', 'vendor_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-input v-if="record.editable" :type="col == 'max_character_length' ? 'number' : 'text'" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e.target.value, index, col)" />
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="type" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeUsbPrinter(e, index, 'type')">
                                            <a-select-option key="1" value="1">Thermal</a-select-option>
                                            <a-select-option key="2" value="2">Dot Matrix</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            {{_.startCase(text)}}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="record.editable">
                                            <a-button @click="() => saveUsbPrinter(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelUsbPrinter(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="editingKeyUsbPrinter !== ''" @click="() => editUsbPrinter(index)" class="btn btn-warning btn-sm">Edit</a-button>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input> -->
                    </a-tab-pane>
                    <a-tab-pane tab="Kitchen Printing" key="5">
                        <base-input label="Kitchen Printer Areas">
                            <br>
                            <a-table :columns="kitchenPrinterAreaColumns" :dataSource="kitchenPrinterAreas" :pagination="false" size="small" bordered>
                                <template slot="name" slot-scope="text, record, index">
                                    <div>
                                        <a-input v-if="record.editable" type="text" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrinterArea(e.target.value, index, 'name')" :disabled="$attrs.viewMode"/>
                                        <template v-else>
                                            {{text}}
                                        </template>
                                    </div>
                                </template>
                                <template v-for="col in ['primary_printer_id', 'secondary_printer_id']" :slot="col" slot-scope="text, record, index">
                                    <div :key="col">
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrinterArea(e, index, col)" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="(printer) in networkPrinters" :key="printer.id" :value="printer.id" >{{ printer.name }}</a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <!-- {{_.startCase(text)}} -->
                                            {{ networkPrinters.find(printer => printer.id == text) ? networkPrinters.find(printer => printer.id == text).name : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="default" slot-scope="text, record, index">
                                    <div>
                                        <a-checkbox @change="e => handleChangeKitchenPrinterArea(e.target.checked, index, 'default')" :value="text" :checked="record.default" :disabled="$attrs.viewMode || !record.editable"/>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == kitchenPrinterAreas.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" @click="() => addKitchenPrinterArea()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveKitchenPrinterArea(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelKitchenPrinterArea(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" @click="() => editKitchenPrinterArea(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyKitchenPrinterArea !== ''" title="Sure to delete?" @confirm="() => deleteKitchenPrinterArea(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>

                        <base-input label="Kitchen Printer Routing" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableKitchenPrintingRouting" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input label="Docket Clipping Space" class="d-flex justify-content-between align-items-center">
                            <a-switch v-model="enableDocketClippingSpace" :disabled="$attrs.viewMode" />
                        </base-input>

                        <base-input label="Kitchen Printing Routes" v-if="enableKitchenPrintingRouting">
                            <br>
                            <a-table :columns="kitchenPrintingRouteColumns" :dataSource="kitchenPrintingRoutes" :pagination="false" size="small" bordered>
                                <template slot="category_ids" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" :value="text" :filterOption="filterOption" option-filter-prop="children" mode="multiple" @change="e => handleChangeKitchenPrintingRoute(e, index, 'category_ids')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="cat in kitchenCategoryOptions" :key="cat.id"  >
                                                {{ cat.category_name }}
                                            </a-select-option>
                                        </a-select>
                                        <template v-else>
                                            <a-tag v-for="value in text" :key="value" color="#00BFFF" >
                                                {{ kitchenCategoryOptions.find(cat => cat.id == value) ? kitchenCategoryOptions.find(cat => cat.id == value).category_name : value }}
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template slot="kitchen_printer_area_id" slot-scope="text, record, index">
                                    <div>
                                        <a-select v-if="record.editable" style="margin: -5px 0" :value="text" @change="e => handleChangeKitchenPrintingRoute(e, index, 'kitchen_printer_area_id')" :disabled="$attrs.viewMode">
                                            <a-select-option v-for="area in kitchenPrinterAreas" :key="area.id" :value="area.id">
                                                {{ area.name }}
                                            </a-select-option>
                                            <!-- <a-select-option v-for="area in kitchenPrinterAreas" :key="area.id" :value="area.id"></a-select-option>
                                                {{ area.name }} ({{ area.id }})
                                            </a-select-option> -->
                                        </a-select>
                                        <template v-else>
                                            {{ kitchenPrinterAreas.find(area => area.id == text) ? kitchenPrinterAreas.find(area => area.id == text).name : '' }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
                                        <span v-if="index == kitchenPrintingRoutes.length - 1">
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" @click="() => addKitchenPrintingRoute()" class="btn btn-success btn-sm">Add Printer</a-button>
                                        </span>
                                        <span v-else-if="record.editable">
                                            <a-button @click="() => saveKitchenPrintingRoute(index)" style="margin-right: 5px;" class="btn btn-success btn-sm">Save</a-button>
                                            <a-popconfirm title="Sure to cancel?" @confirm="() => cancelKitchenPrintingRoute(index)">
                                                <a-button class="btn btn-danger btn-sm">Cancel</a-button>
                                            </a-popconfirm>
                                        </span>
                                        <span v-else>
                                            <a-button :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" @click="() => editKitchenPrintingRoute(index)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</a-button>
                                            <a-popconfirm :disabled="$attrs.viewMode || editingKeyKitchenPrintingRoute !== ''" title="Sure to delete?" @confirm="() => deleteKitchenPrintingRoute(index)">
                                                <a-button class="btn btn-danger btn-sm">Delete</a-button>
                                            </a-popconfirm>
                                        </span>
                                    </div>
                                </template>
                            </a-table>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="6" forceRender>
                        <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups_append }"
                            :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey"
                            :showErrors="false" />
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div class='mt-5' v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'"
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right"
                        @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right"
                        @click.prevent="update">Update</button>
                </div>
                <div v-else
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right"
                        @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'
var component_x;
const site_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];

export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function () {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Site?field_name=name', null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id', null)

        // this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view'  , null)
        this.locationOptions = this.$attrs.locationOptions

        if (this.isJsonString(accSystemModuleRequest.meta) == true) {
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if (accSystemModule != null) {
                if (accSystemModule.form_mode != undefined) {
                    this.customFormMode = accSystemModule.form_mode
                }
                if (accSystemModule.customized_forms != undefined) {
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this

        // get brands
        let brands = await HTTPRequest.getRequest(component_x.endPoint + 'brands/get_valid_brands', null, "BXI-File")
        this.brandList = brands

        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'sites/' + component_x.profileId, null)
            if (data == undefined) {
                component_x.$router.go()
            } else {
                if (data["error"] == undefined) {
                    component_x.inputCode = data["refcode"]
                    this.site = data
                    if (data["location_path"] != null) component_x.inputLocation = JSON.parse(data["location_path"])
                    component_x.inputName = data["name"]
                    component_x.contactPerson = data["contact_person"]
                    component_x.contactNumber = data["telephone"]
                    component_x.inputSiteType = data["site_type_id"]
                    component_x.inputCompany = data["company_id"]
                    component_x.inputTin = data["tin"]
                    component_x.inputAddress = data["address"]
                    component_x.inputAreaCode = data["area_code"]
                    component_x.ipAddress = data["ip_address"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    component_x.checkboxes.isLive = data["is_live"]
                    component_x.checkboxes.isRemote = data["is_remote"]
                    component_x.companyName = data["company_name"]
                    component_x.siteTypeName = data["site_type"]
                    component_x.checkboxes.isAllowedMergingSales = data["is_allowed_merging_sales"]
                    component_x.checkboxes.canDownloadPosInventory = data["can_download_pos_inventory"]
                    component_x.checkboxes.isEnableSiteReset = data["is_for_resetting"]
                    // component_x.checkboxes.canDownloadPosSitePricing = data["can_download_pos_site_pricing"]
                    // component_x.checkboxes.canDownloadTerminalSettings = data["can_download_terminal_settings"]
                    component_x.checkboxes.isStrickLotCodes = data["is_strick_lot_codes"]
                    // component_x.checkboxes.isSupportingZippedDocument = data["is_supporting_zipped_document"]
                    component_x.checkboxes.isEnableEcomPos = data["ecomm_terminal_id"] != undefined && data["ecomm_terminal_id"] != null ? true : false
                    component_x.terminalName = data["terminal_name"]
                    component_x.inputTerminal = data["ecomm_terminal_id"]
                    component_x.disableReplication = data["replicated_site_id"] != undefined && data["replicated_site_id"] != null ? true : false
                    component_x.checkboxes.isEnableSiteReplication = data["replicated_site_id"] != undefined && data["replicated_site_id"] != null ? true : false
                    component_x.inputReplicateSiteId = data["replicated_site_id"]
                    component_x.inputEmail = data["email"] ? data["email"].split(',').map(email => email.trim()).filter(Boolean) : []
                    component_x.inputBrandName = data["site_brand"]
                    component_x.inputOwnershipType = data["ownership_type"]
                    component_x.enableBranchConsole = data["enableBranchConsole"]
                    component_x.branch_console_host = data["branch_console_host"]
                    component_x.branch_console_master_terminal = data["branch_console_master_terminal"]
                    component_x.centralizationMode = data["centralizationMode"].toString()
                    component_x.inputNoOfTables = data["no_of_tables"]


                    if (data["serialized_sublocation"]) {
                        component_x.inputSublocationCode = data["serialized_sublocation"]["code"]
                        component_x.inputSublocationName = data["serialized_sublocation"]["name"]
                        component_x.inputSublocationType = data["serialized_sublocation"]["sublocation_type"]
                        component_x.inputSalesman = data["serialized_sublocation"]["salesman_id"]
                        component_x.salesmanName = data["serialized_sublocation"]["salesman_name"]
                        component_x.inputDescription = data["serialized_sublocation"]["description"]
                        component_x.inputTags = data["serialized_sublocation"]["tags"]
                        component_x.inputSublocation = data["serialized_sublocation"]["id"]
                        component_x.sublocationName = data["serialized_sublocation"]["name"]
                    }

                    component_x.usbPrinters = data["terminal_printers"] || []
                    component_x.cacheUsbPrinters = structuredClone(component_x.usbPrinters);

                    component_x.networkPrinters = data["network_printers"] || []
                    component_x.cacheNetworkPrinters = structuredClone(component_x.networkPrinters);
                    component_x.networkPrinters.push({
                        name: null,
                        max_character_length: null,
                        type: null,
                        network_address: null,
                        is_default: false,
                        is_dispatch: false,
                        editable: true
                    })
                    component_x.networkPrinterCounter = data["network_printer_counter"] || 0

                    component_x.kitchenPrinterAreas = data["kitchen_printer_areas"] || []
                    component_x.cacheKitchenPrinterAreas = structuredClone(component_x.kitchenPrinterAreas);
                    component_x.kitchenPrinterAreas.push({
                        name: null,
                        primary_printer_id: null,
                        secondary_printer_id: null,
                        default: false,
                        editable: true
                    })
                    component_x.kitchenPrinterAreaCounter = data["kitchen_printer_area_counter"] || 0

                    component_x.enableDocketClippingSpace = data["enable_docket_clipping_space"] || false
                    component_x.enableKitchenPrintingRouting = data["enable_kitchen_printing_routing"] || false
                    component_x.kitchenPrintingRoutes = data["kitchen_printing_routes"] || []
                    component_x.cacheKitchenPrintingRoutes = structuredClone(component_x.kitchenPrintingRoutes);
                    component_x.kitchenPrintingRoutes.push({
                        category_ids: [],
                        kitchen_printer_area_id: null,
                        editable: true
                    })

                    let kitchen_category = await HTTPRequest.getRequest(
                        component_x.endPoint + "kitchen_categories/get_valid_kitchen_categories",
                        null,
                        "BXI-File"
                    );
                    component_x.kitchenCategoryOptions = kitchen_category; 

                    var terminals = await HTTPRequest.getRequest(component_x.endPoint + 'terminals?site_id=' + component_x.profileId, null)
                    this.siteTerminals = terminals.data

                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
        this.dynamicFormKey++;
    },
    data: function () {
        return {
            // Location Implem
            inputLocation: null,
            locationOptions: [],

            inputCode: '',
            inputName: '',
            inputSiteType: '',
            isSiteTypeDisabled: false,
            siteTypeName: '',
            inputBrandName: '',
            inputOwnershipType: '',
            brandList: [],
            inputCompany: '',
            companyName: '',
            inputTin: '',
            inputAddress: '',
            inputAreaCode: '',
            ipAddress: '',
            inputRemark: '',
            contactNumber: '',
            contactPerson: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            showDetails: true,
            inputEmail: [],
            checkboxes: {
                isLive: null,
                isRemote: null,
                isAllowedMergingSales: null,
                canDownloadPosInventory: null,
                // canDownloadPosSitePricing: null,
                // canDownloadTerminalSettings: null,
                isStrickLotCodes: null,
                // isSupportingZippedDocument: null,
                isEnableEcomPos: null,
                isEnableSiteReplication: null,
                isEnableSiteReset: null
            },
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            errors: [],

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            site: {},
            formErrors: [],

            inputSublocationCode: '',
            inputSublocationName: '',
            inputSite: '',
            inputSublocationType: '',
            sublocationTypeOptions: [
                { key: null, value: null },
                { key: "T", value: "Truck" },
                { key: "S", value: "Store-front" },
                { key: "B", value: "Backroom" }
            ],
            salesmanName: '',
            inputSalesman: '',
            inputDescription: '',
            inputTags: '',
            sublocationName: '',
            inputSublocation: '',
            terminalName: '',
            inputTerminal: '',
            inputReplicateSiteId: '',
            disableReplication: false,

            enableBranchConsole: false,
            branch_console_host: null,
            branch_console_master_terminal: null,
            centralizationMode: "0",
            siteTerminals: [],
            inputNoOfTables: null,
            siteHistoryColumns: site_histories_column,
            siteHistoryData: null,
            loading: false,
            pagination: false,
            ownerAccount: secureStorage.getItem("isAccountOwner"),

            // USB Printer
            editingKeyUsbPrinter: '',
            usbPrinterColumns: [
                {
                    title: 'Terminal Name',
                    dataIndex: 'terminal_name',
                    width: 240,
                    fixed: 'left',
                },
                {
                    title: 'Enable Printer',
                    dataIndex: 'is_enabled',
                    width: 120,
                    scopedSlots: { customRender: 'is_enabled' },
                },
                {
                    title: 'Max Characters',
                    dataIndex: 'max_character_length',
                    width: 100,
                    scopedSlots: { customRender: 'max_character_length' },
                },
                // {
                //     title: 'Type',
                //     dataIndex: 'receipt_type',
                //     width: 120,
                //     scopedSlots: { customRender: 'type' },
                // },
                {
                    title: 'Product ID',
                    dataIndex: 'product_id',
                    width: 150,
                    scopedSlots: { customRender: 'product_id' },
                },
                {
                    title: 'Vendor ID',
                    dataIndex: 'vendor_id',
                    width: 150,
                    scopedSlots: { customRender: 'vendor_id' },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'actions' },
                },
            ],
            usbPrinters: [],
            cacheUsbPrinters: [],

            // Network Printer
            editingKeyNetworkPrinter: '',
            networkPrinterColumns: [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    width: 200,
                    scopedSlots: { customRender: 'name' },
                    fixed: 'left',
                },
                {
                    title: 'Max Characters',
                    dataIndex: 'max_character_length',
                    width: 100,
                    scopedSlots: { customRender: 'max_character_length' },
                },
                {
                    title: 'Type',
                    dataIndex: 'type',
                    width: 100,
                    scopedSlots: { customRender: 'type' },
                },
                {
                    title: 'Network Address',
                    dataIndex: 'network_address',
                    width: 100,
                    scopedSlots: { customRender: 'network_address' },
                },
                {
                    title: 'USB Fallback',
                    dataIndex: 'is_default',
                    align: 'center',
                    width: 80,
                    scopedSlots: { customRender: 'is_default' },
                },
                {
                    title: 'Dispatch Fallback',
                    dataIndex: 'is_dispatch',
                    align: 'center',
                    width: 80,
                    scopedSlots: { customRender: 'is_dispatch' },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'actions' },
                    fixed: 'right',
                },
            ],
            networkPrinters: [],
            cacheNetworkPrinters: [],
            networkPrinterCounter: 0,
            networkPrinterTypes: [
                { id: 1, name: "Thermal" },
                { id: 2, name: "Dot Matrix" }
            ],

            // Kitchen Printer Area
            editingKeyKitchenPrinterArea: '',
            kitchenPrinterAreaColumns: [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    width: 260,
                    scopedSlots: { customRender: 'name' },
                    fixed: 'left',
                },
                {
                    title: 'Primary Printer',
                    dataIndex: 'primary_printer_id',
                    width: 200,
                    scopedSlots: { customRender: 'primary_printer_id' }
                },
                {
                    title: 'Secondary Printer',
                    dataIndex: 'secondary_printer_id',
                    width: 200,
                    scopedSlots: { customRender: 'secondary_printer_id' }
                },
                {
                    title: 'Default',
                    dataIndex: 'default',
                    align: 'center',
                    width: 100,
                    scopedSlots: { customRender: 'default' }
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'actions' },
                    fixed: 'right',
                },
            ],
            kitchenPrinterAreas: [],
            cacheKitchenPrinterAreas: [],
            kitchenPrinterAreaCounter: 0,

            // Kitchen Printing Route
            enableKitchenPrintingRouting: false,
            editingKeyKitchenPrintingRoute: '',
            kitchenPrintingRouteColumns: [
                {
                    title: 'Kitchen Categories',
                    dataIndex: 'category_ids',
                    width: 380,
                    scopedSlots: { customRender: 'category_ids' },
                    fixed: 'left'
                },
                {
                    title: 'Kitchen Printer Area',
                    dataIndex: 'kitchen_printer_area_id',
                    width: 380,
                    scopedSlots: { customRender: 'kitchen_printer_area_id' }
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'actions' },
                    fixed: 'right',
                }
            ],
            kitchenPrintingRoutes: [],
            cacheKitchenPrintingRoutes: [],

            kitchenCategoryOptions: [],
            enableDocketClippingSpace: false
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings (newFormSettings, settingsGrouping, errors) {
            var formSettingsCopy = this.site
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if (this.customFormMode == 3) {
                this.errors = errors
            }

            this.site = mergedHash
        },
        isJsonString (str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails () {
            this.showDetails = true
        },
        async openHistory () {
            this.showDetails = false
            var siteHistoryData = await HTTPRequest.getRequest(
            this.endPoint +
                "site_update_histories?site_id=" +
                this.site.id,
            null,
            null
            );
            this.siteHistoryData = siteHistoryData;
        },
        sublocationEndpoint (input) {
            return this.endPoint + '/sublocations?name=' + input;
        },
        getSublocation (group) {
            this.sublocationName = group.display;
            this.inputSublocation = group.value;
        },
        salesmanEndpoint (input) {
            return this.endPoint + '/salesmen?name=' + input;
        },
        getSalesman (group) {
            this.salesmanName = group.display;
            this.inputSalesman = group.value;
        },
        companyEndpoint (input) {
            return this.endPoint + '/companies?name=' + input;
        },
        termialEndpoint (input) {
            return this.endPoint + '/terminals?name=' + input;
        },
        sitesEndpoint (input) {
            return this.endPoint + '/sites/get_valid_sites?name=' + input;
        },
        getCompany (group) {
            this.companyName = group.display;
            this.inputCompany = group.value;
        },
        getTerminal (group) {
            console.log(group)
            this.terminalName = group.display;
            this.inputTerminal = group.value;
        },
        getSite (group) {
            this.siteName = group.display;
            this.inputReplicateSiteId = group.value;
        },
        siteTypeEndpoint (input) {
            return this.endPoint + '/site_types?name=' + input;
        },
        getSiteType (group) {
            this.siteTypeName = group.display;
            this.inputSiteType = group.value;
        },
        emails () {
            return this.inputEmail.map(email => email.trim()).filter(Boolean)
        },
        formattedDisplay (result) {
            return result.name + ' [' + result.code + ']';
        },
        validateForm () {
            this.errors = [];
            // this.errors.push(ValidateField.required('Site Reference Code', this.inputCode));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Reference Code', this.inputCode));
            this.errors.push(ValidateField.required('Site Name', this.inputName));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Name', this.inputName));
            this.errors.push(ValidateField.required('Ownership Type', this.inputOwnershipType));
            this.errors.push(ValidateField.required('Site Type', this.inputSiteType));
            this.errors.push(ValidateField.required('Company', this.inputCompany));
            this.errors.push(ValidateField.required('TIN Number', this.inputTin));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('TIN Number', this.inputTin));
            this.errors.push(ValidateField.alphanumericWithNewline('Site Address', this.inputAddress));
            this.errors.push(ValidateField.alphanumericWithSpace('Area Code', this.inputAreaCode));
            this.errors.push(ValidateField.charMinAndMax('Area Code', this.inputAreaCode, 0, 100));
            this.errors.push(ValidateField.required('Location', this.inputLocation));
            const emails = this.emails()
            if (emails.length > 4) this.errors.push('Only a maximum of 4 email addresses are allowed');
            this.errors.push(ValidateField.charMinAndMax('Email', emails.join(','), 0, 255));
            emails.forEach(email => this.errors.push(ValidateField.emailFormat('Email', email)));

            if (this.checkboxes.isEnableEcomPos != null && this.checkboxes.isEnableEcomPos != "") {
                this.errors.push(ValidateField.required('Terminal', this.inputTerminal));
            }
            if (this.checkboxes.isEnableSiteReplication != null && this.checkboxes.isEnableSiteReplication != false) {
                this.errors.push(ValidateField.required('Site Replication', this.inputReplicateSiteId))
            }
            //this.errors.push(ValidateField.isNull('Support Zipped Document', this.checkboxes.isSupportingZippedDocument));
            if (this.profileId == 0) {
                this.errors.push(ValidateField.required('Sublocation Name', this.inputSublocationName));
                this.errors.push(ValidateField.required('Sublocation Code', this.inputSublocationCode));
            // } else {
            //     this.errors.push(ValidateField.required('Sublocation Name', this.sublocationName));
            }
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Description', this.inputDescription));
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Tags', this.inputTags));
            
            if (this.enableBranchConsole) {
                this.errors.push(ValidateField.required('Branch Console Host', this.branch_console_host));

                const ipRegex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                if (!ipRegex.test(this.branch_console_host)) {
                    this.errors.push("Branch Console Host must be a valid IP address");
                }
                
                this.errors.push(ValidateField.required('Branch Console Master Terminal', this.branch_console_master_terminal));
            }
            this.inputNoOfTables = this.inputNoOfTables ?  parseInt(this.inputNoOfTables) : 0
            

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            if (!this.validateForm()) {
                let kitchen_printing_routes = this.kitchenPrintingRoutes.slice(0, -1).map(route => {
                    return {
                        id: route.id || null,
                        category_ids: route.category_ids,
                        kitchen_printer_area_id: route.kitchen_printer_area_id
                    }
                })
                

                var sitePayload = {
                    site: {
                        name: this.inputName.trim(), 
                        refcode: this.inputCode.trim(), 
                        location_id: this.inputLocation[this.inputLocation.length - 1], 
                        location_path: JSON.stringify(this.inputLocation),
                        site_brand: this.inputBrandName,
                        ownership_type: this.inputOwnershipType,
                        site_type_id: this.inputSiteType, 
                        company_id: this.inputCompany,
                        tin: this.inputTin, 
                        address: this.inputAddress, 
                        area_code: this.inputAreaCode, 
                        ip_address: this.ipAddress,
                        remark: this.inputRemark, 
                        contact_person: this.contactPerson, 
                        telephone: this.contactNumber,
                        is_live: this.checkboxes.isLive,
                        is_remote: this.checkboxes.isRemote,
                        is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                        can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                        // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                        // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                        is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                        is_for_resetting: this.checkboxes.isEnableSiteReset,
                        // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                        email: this.emails().join(','),
                        ecomm_terminal_id: this.inputTerminal,
                        replicated_site_id: this.inputReplicateSiteId,
                        sublocation: {
                            name: this.inputSublocationName.trim(), code: this.inputSublocationCode.trim(),
                            sublocation_type: this.inputSublocationType, salesman_id: this.inputSalesman,
                            description: this.inputDescription, tags: this.inputTags
                        },
                        enableBranchConsole: this.enableBranchConsole,
                        branch_console_host: this.enableBranchConsole ? this.branch_console_host : null,
                        branch_console_master_terminal: this.enableBranchConsole ? this.branch_console_master_terminal : null,
                        centralizationMode: parseInt(this.centralizationMode),
                        no_of_tables: this.inputNoOfTables,
                        terminal_printers: this.usbPrinters,
                        network_printers: this.networkPrinters.slice(0, -1),
                        network_printer_counter: this.networkPrinterCounter,
                        enable_docket_clipping_space: this.enableDocketClippingSpace,
                        enable_kitchen_printing_routing: this.enableKitchenPrintingRouting,
                        kitchen_printer_areas: this.kitchenPrinterAreas.slice(0, -1),
                        kitchen_printer_area_counter: this.kitchenPrinterAreaCounter,
                        kitchen_printing_routes: kitchen_printing_routes
                    }
                }
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sites', null, { site: mergedHash }, "BXI-File")
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                let kitchen_printing_routes = this.kitchenPrintingRoutes.slice(0, -1).map(route => {
                    return {
                        id: route.id || null,
                        category_ids: route.category_ids,
                        kitchen_printer_area_id: route.kitchen_printer_area_id
                    }
                })

                var sitePayload = {
                    site: {
                        name: this.inputName.trim(), 
                        refcode: this.inputCode.trim(), 
                        location_id: this.inputLocation[this.inputLocation.length - 1], 
                        location_path: JSON.stringify(this.inputLocation),
                        site_brand: this.inputBrandName,
                        ownership_type: this.inputOwnershipType,
                        site_type_id: this.inputSiteType, company_id: this.inputCompany,
                        tin: this.inputTin, 
                        address: this.inputAddress,
                        area_code: this.inputAreaCode,
                        remark: this.inputRemark, 
                        contact_person: this.contactPerson, 
                        telephone: this.contactNumber,
                        is_live: this.checkboxes.isLive,
                        is_remote: this.checkboxes.isRemote, 
                        ip_address: this.ipAddress,
                        is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                        can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                        // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                        // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                        is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                        is_for_resetting: this.checkboxes.isEnableSiteReset,
                        // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                        sublocation_id: this.inputSublocation, email: this.emails().join(','),
                        ecomm_terminal_id: this.inputTerminal, replicated_site_id: this.inputReplicateSiteId,
                        sublocation: {
                            name: this.sublocationName
                        },
                        enableBranchConsole: this.enableBranchConsole,
                        branch_console_host: this.enableBranchConsole ? this.branch_console_host : null,
                        branch_console_master_terminal: this.enableBranchConsole ? this.branch_console_master_terminal : null,
                        centralizationMode: parseInt(this.centralizationMode),
                        no_of_tables: this.inputNoOfTables,
                        terminal_printers: this.usbPrinters,
                        network_printers: this.networkPrinters.slice(0, -1),
                        network_printer_counter: this.networkPrinterCounter,
                        enable_docket_clipping_space: this.enableDocketClippingSpace,
                        enable_kitchen_printing_routing: this.enableKitchenPrintingRouting,
                        kitchen_printer_areas: this.kitchenPrinterAreas.slice(0, -1),
                        kitchen_printer_area_counter: this.kitchenPrinterAreaCounter,
                        kitchen_printing_routes: kitchen_printing_routes
                    }

                }
                // var sitePayload =
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                // console.log(mergedHash)
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sites/' + this.profileId, null, { site: mergedHash }, "BXI-File")
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        onChange(e) {
            console.log(e)
        },

        // USB Printer
        validateUsbPrinter(printer) {
            this.errors = [];

            // this.errors.push(ValidateField.required('Max Characters', printer.max_character_length));
            this.errors.push(ValidateField.positiveNumber('Max Characters', printer.max_character_length));
            this.errors.push(ValidateField.isWholeNumber('Max Characters', printer.max_character_length));

            // this.errors.push(ValidateField.required('Type', printer.type));

            // this.errors.push(ValidateField.required('Product ID', printer.product_id));
            this.errors.push(ValidateField.alphanumeric('Product ID', printer.product_id));

            // this.errors.push(ValidateField.required('Vendor ID', printer.vendor_id));
            this.errors.push(ValidateField.alphanumeric('Vendor ID', printer.vendor_id));

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        handleChangeUsbPrinter(value, index, column) {
            const newData = [...this.usbPrinters];
            const target = newData[index];
            if (target) {
                target[column] = value;
                target['receipt_type'] = 1
                this.usbPrinters = newData;
            }
        },
        editUsbPrinter(index) {
            const newData = [...this.usbPrinters];
            const target = newData[index]
            this.editingKeyUsbPrinter = index;
            if (target) {
                target.editable = true;
                this.usbPrinters = [...newData];
            }
        },
        saveUsbPrinter(index) {
            if (!this.validateUsbPrinter(this.usbPrinters[index])) {
                const newData = [...this.usbPrinters];
                const newCacheData = [...this.cacheUsbPrinters];
                const target = newData[index]
                const targetCache = newCacheData[index]
                if (target && targetCache) {
                    delete target.editable;
                    if (!target['is_enabled']) {
                        target['receipt_type'] = null
                        target['max_character_length'] = null
                        target['product_id'] = null
                        target['vendor_id'] = null
                    }
                    this.usbPrinters = newData;
                    Object.assign(targetCache, target);
                    this.cacheUsbPrinters = newCacheData;
                }
                this.editingKeyUsbPrinter = '';
            }
        },
        cancelUsbPrinter(index) {
            const newData = [...this.usbPrinters];
            const target = newData[index]
            this.editingKeyUsbPrinter = '';
            if (target) {
                Object.assign(target, this.cacheUsbPrinters[index])
                delete target.editable;
                this.usbPrinters = newData;
            }
        },

        // Network Printer
        validateNetworkPrinter(printer) {
            this.errors = [];
            this.errors.push(ValidateField.required('Name', printer.name));

            this.errors.push(ValidateField.required('Max Characters', printer.max_character_length));
            this.errors.push(ValidateField.positiveNumber('Max Characters', printer.max_character_length));
            this.errors.push(ValidateField.isWholeNumber('Max Characters', printer.max_character_length));

            // this.errors.push(ValidateField.required('Type', printer.type));
            
            this.errors.push(ValidateField.required('Network Address', printer.network_address));
            const ipRegex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            if (!ipRegex.test(printer.network_address)) {
                this.errors.push("Network Address must be a valid IP address");
            }

            if (printer.is_default) {
                let default_exists = 0
                this.networkPrinters.forEach(printer => {
                    if (printer.is_default) {
                        default_exists ++ 
                    }
                })
                if (default_exists > 1) {
                    this.errors.push("Only one default printer is allowed per site.")
                }
            }

            if (printer.is_dispatch) {
                let dispatch_exists = 0
                this.networkPrinters.forEach(printer => {
                    if (printer.is_dispatch) {
                        dispatch_exists ++ 
                    }
                })
                if (dispatch_exists > 1) {
                    this.errors.push("Only one dispatch printer is allowed per site.")
                }
            }

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        handleChangeNetworkPrinter(value, index, column) {
            const newData = [...this.networkPrinters];
            const target = newData[index];
            if (target) {
                target[column] = value;
                this.networkPrinters = newData;
            }
        },
        addNetworkPrinter() {
            if (!this.validateNetworkPrinter(this.networkPrinters[this.networkPrinters.length - 1])) {
                this.networkPrinterCounter++
                this.networkPrinters[this.networkPrinters.length - 1].id = this.networkPrinterCounter
                delete this.networkPrinters[this.networkPrinters.length - 1].editable
                this.networkPrinters.push({
                    name: null,
                    max_character_length: null,
                    type: null,
                    network_address: null,
                    editable: true
                })
                this.editingKeyNetworkPrinter = ''
            }
        },
        editNetworkPrinter(index) {
            const newData = [...this.networkPrinters];
            const target = newData[index]
            this.editingKeyNetworkPrinter = index;
            if (target) {
                target.editable = true;
                this.networkPrinters = [...newData];
                delete this.networkPrinters[this.networkPrinters.length - 1].editable
            }
        },
        saveNetworkPrinter(index) {
            if (!this.validateNetworkPrinter(this.networkPrinters[index])) {
                const newData = [...this.networkPrinters];
                const newCacheData = [...this.cacheNetworkPrinters];
                const target = newData[index]
                const targetCache = newCacheData[index]
                if (target && targetCache) {
                    delete target.editable;
                    this.networkPrinters = newData;
                    Object.assign(targetCache, target);
                    this.cacheNetworkPrinters = newCacheData;
                    this.networkPrinters[this.networkPrinters.length - 1].editable = true
                }
                this.editingKeyNetworkPrinter = '';
            }
        },
        cancelNetworkPrinter(index) {
            const newData = [...this.networkPrinters];
            const target = newData[index]
            this.editingKeyNetworkPrinter = '';
            if (target) {
                Object.assign(target, this.cacheNetworkPrinters[index])
                delete target.editable;
                this.networkPrinters = newData;
                this.networkPrinters[this.networkPrinters.length - 1].editable = true
            }
        },
        deleteNetworkPrinter(index) {
            let printer_assigned = 0
            this.kitchenPrinterAreas.forEach(area => {
                if (area.primary_printer_id == this.networkPrinters[index].id || area.secondary_printer_id == this.networkPrinters[index].id) {
                    printer_assigned ++ 
                }
            })

            if (printer_assigned) {
                this.$notification['error']({
                    message: 'Network Printer In Use',
                    description: 'This network printer is currently assigned to a kitchen printer area and cannot be deleted.',
                })
            } else {
                const newData = [...this.networkPrinters];
                newData.splice(index, 1);
                this.networkPrinters = newData;
                this.$notification['success']({
                    message: 'Network Printer Deleted',
                    description: 'The network printer has been deleted successfully.',
                })
            }
        },

        // Kitchen Printer Area
        validateKitchenPrinterArea(kitchen_printer_area) {
            this.errors = [];
            this.errors.push(ValidateField.required('Name', kitchen_printer_area.name));

            this.errors.push(ValidateField.required('Primary Printer', kitchen_printer_area.primary_printer_id));

            if(kitchen_printer_area.primary_printer_id == kitchen_printer_area.secondary_printer_id) {
                this.errors.push("Primary and Secondary printer cannot be the same")
            }

            // this.errors.push(ValidateField.required('Type', kitchen_printer_area.type));
            if (kitchen_printer_area.default) {
                let default_exists = 0
                this.kitchenPrinterAreas.forEach(kitchen_printer_area => {
                    if (kitchen_printer_area.default) {
                        default_exists ++ 
                    }
                })
                if (default_exists > 1) {
                    this.errors.push("Only one default kitchen printer area is allowed per site.")
                }
            }

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        handleChangeKitchenPrinterArea(value, index, column) {
            const newData = [...this.kitchenPrinterAreas];
            const target = newData[index];
            if (target) {
                target[column] = value;
                this.kitchenPrinterAreas = newData;
            }
        },
        addKitchenPrinterArea() {
            if (!this.validateKitchenPrinterArea(this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1])) {
                this.kitchenPrinterAreaCounter++
                this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1].id = this.kitchenPrinterAreaCounter
                delete this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1].editable
                this.kitchenPrinterAreas.push({
                    name: null,
                    network_printer: null,
                    editable: true
                })
                this.editingKeyKitchenPrinterArea = ''
            }
            console.log(this.kitchenPrinterAreas)
        },
        editKitchenPrinterArea(index) {
            const newData = [...this.kitchenPrinterAreas];
            const target = newData[index]
            this.editingKeyKitchenPrinterArea = index;
            if (target) {
                target.editable = true;
                this.kitchenPrinterAreas = [...newData];
                delete this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1].editable
            }
        },
        saveKitchenPrinterArea(index) {
            if (!this.validateKitchenPrinterArea(this.kitchenPrinterAreas[index])) {
                const newData = [...this.kitchenPrinterAreas];
                const newCacheData = [...this.cacheKitchenPrinterAreas];
                const target = newData[index]
                const targetCache = newCacheData[index]
                if (target && targetCache) {
                    delete target.editable;
                    this.kitchenPrinterAreas = newData;
                    Object.assign(targetCache, target);
                    this.cacheKitchenPrinterAreas = newCacheData;
                    this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1].editable = true
                }
                this.editingKeyKitchenPrinterArea = '';
            }
        },
        cancelKitchenPrinterArea(index) {
            const newData = [...this.kitchenPrinterAreas];
            const target = newData[index]
            this.editingKeyKitchenPrinterArea = '';
            if (target) {
                Object.assign(target, this.cacheKitchenPrinterAreas[index])
                delete target.editable;
                this.kitchenPrinterAreas = newData;
                this.kitchenPrinterAreas[this.kitchenPrinterAreas.length - 1].editable = true
            }
        },
        deleteKitchenPrinterArea(index) {
            let area_assigned = 0
            this.kitchenPrintingRoutes.forEach(route => {
                if (route.kitchen_printer_area_id == this.kitchenPrinterAreas[index].id) {
                    area_assigned ++ 
                }
            })

            if (area_assigned) {
                this.$notification['error']({
                    message: 'Kitchen Printer Area In Use',
                    description: 'This kitchen printer area is currently assigned to a kitchen printing route and cannot be deleted.',
                })
            } else {
                const newData = [...this.kitchenPrinterAreas];
                newData.splice(index, 1);
                this.kitchenPrinterAreas = newData;
                this.$notification['success']({
                    message: 'Kitchen Printer Area Deleted',
                    description: 'The kitchen printer area has been deleted successfully.',
                })
            }
        },

        // Kitchen Printing Route
        validateKitchenPrintingRoute(kitchen_printing_route) {
            this.errors = [];

            this.errors.push(ValidateField.isEmpty('Kitchen Category', kitchen_printing_route.category_ids))
            this.errors.push(ValidateField.required('Kitchen Printer Area', kitchen_printing_route.kitchen_printer_area_id))

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        handleChangeKitchenPrintingRoute(value, index, column) {
            const newData = [...this.kitchenPrintingRoutes];
            const target = newData[index];
            if (target) {
                target[column] = value;
                this.kitchenPrintingRoutes = newData;
            }
        },
        addKitchenPrintingRoute() {
            if (!this.validateKitchenPrintingRoute(this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1])) {
                this.kitchenPrintingRouteCounter++
                this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1].id = this.kitchenPrintingRouteCounter
                delete this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1].editable
                this.kitchenPrintingRoutes.push({
                    name: null,
                    network_printer: null,
                    editable: true
                })
                this.editingKeyKitchenPrintingRoute = ''
            }
        },
        editKitchenPrintingRoute(index) {
            const newData = [...this.kitchenPrintingRoutes];
            const target = newData[index]
            this.editingKeyKitchenPrintingRoute = index;
            if (target) {
                target.editable = true;
                this.kitchenPrintingRoutes = [...newData];
                delete this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1].editable
            }
        },
        saveKitchenPrintingRoute(index) {
            if (!this.validateKitchenPrintingRoute(this.kitchenPrintingRoutes[index])) {
                const newData = [...this.kitchenPrintingRoutes];
                const newCacheData = [...this.cacheKitchenPrintingRoutes];
                const target = newData[index]
                const targetCache = newCacheData[index]
                if (target && targetCache) {
                    delete target.editable;
                    this.kitchenPrintingRoutes = newData;
                    Object.assign(targetCache, target);
                    this.cacheKitchenPrintingRoutes = newCacheData;
                    this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1].editable = true
                }
                this.editingKeyKitchenPrintingRoute = '';
            }
        },
        cancelKitchenPrintingRoute(index) {
            const newData = [...this.kitchenPrintingRoutes];
            const target = newData[index]
            this.editingKeyKitchenPrintingRoute = '';
            if (target) {
                Object.assign(target, this.cacheKitchenPrintingRoutes[index])
                delete target.editable;
                this.kitchenPrintingRoutes = newData;
                this.kitchenPrintingRoutes[this.kitchenPrintingRoutes.length - 1].editable = true
            }
        },
        deleteKitchenPrintingRoute(index) {
            const newData = [...this.kitchenPrintingRoutes];
            newData.splice(index, 1);
            this.kitchenPrintingRoutes = newData;
        },
    }
}
</script>

<style>
textarea {
    resize: none;
}
</style>
    
